
import React from 'react';

import InvoiceDocument
  from '../../shared/documents/InvoiceDocument';

import InvoiceCreationForm
  from './InvoiceCreationForm.jsx';


const RightLessonRenderer = ({
  content,
  invoice,
}) => {

  if (!content) {
    return null;
  }


  /*
    LECTIA 2.2
    Program interactiv de facturare
  */

  if (content.type === 'invoiceCreationForm') {
    return (
      <InvoiceCreationForm
        content={content}
      />
    );
  }


  /*
    LECTIA 2.1
    Factura pentru analiza
  */

  const documentTypes = [
    'invoiceDocument',
    'invoiceFieldQuiz',
    'invoiceIdentifyParties',
  ];


  if (!documentTypes.includes(content.type)) {
    return null;
  }


  const documentInvoice =
    content.invoice || invoice;


  if (!documentInvoice) {
    return null;
  }


  return (
    <InvoiceDocument
      invoice={documentInvoice}
    />
  );

};


export default RightLessonRenderer;
